import { useSyncExternalStore } from "react";

/** Light, dark, or follow the Mac. Remembered per browser; stamped on <html> as data-theme so the CSS tokens switch. */
export type Theme = "light" | "dark" | "system";
const KEY = "hudhud.theme";
const listeners = new Set<() => void>();

export function getTheme(): Theme {
  try { const v = localStorage.getItem(KEY); return v === "light" || v === "dark" ? v : "system"; } catch { return "system"; }
}
/** Writes the choice to <html> (nothing for "system", so the OS decides) and to localStorage. */
export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === "system") root.removeAttribute("data-theme"); else root.setAttribute("data-theme", t);
}
export function setTheme(t: Theme): void {
  try { if (t === "system") localStorage.removeItem(KEY); else localStorage.setItem(KEY, t); } catch { /* ignore */ }
  applyTheme(t);
  listeners.forEach((l) => l());
}
const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };
export const useTheme = (): Theme => useSyncExternalStore(subscribe, getTheme, () => "system" as Theme);

/** True when the page is currently showing the dark set (an explicit choice, or the Mac in dark). */
export function isDarkNow(): boolean {
  const t = getTheme();
  if (t !== "system") return t === "dark";
  return typeof matchMedia === "function" && matchMedia("(prefers-color-scheme: dark)").matches;
}
